// The current template schema version (mirror of EditorLevel.CurrentSchemaVersion).
export const CURRENT_SCHEMA_VERSION = 1;
// Seed-selection strategy (subset of the reference pipeline). FixedSeed uses `seed` as-is; LevelNumber
// derives the seed from the level number at compile time.
export var SeedStrategy;
(function (SeedStrategy) {
    SeedStrategy[SeedStrategy["FixedSeed"] = 0] = "FixedSeed";
    SeedStrategy[SeedStrategy["LevelNumber"] = 1] = "LevelNumber";
})(SeedStrategy || (SeedStrategy = {}));
// How hard a level is meant to play. Authoring metadata only: the compiler ignores it and it never
// reaches runtime LevelData — it rides with the template so the difficulty curve is versioned next to
// the level. Normal is the default, so templates written before this field keep their meaning.
export var LevelDifficulty;
(function (LevelDifficulty) {
    LevelDifficulty[LevelDifficulty["Normal"] = 0] = "Normal";
    LevelDifficulty[LevelDifficulty["Hard"] = 1] = "Hard";
    LevelDifficulty[LevelDifficulty["VeryHard"] = 2] = "VeryHard";
})(LevelDifficulty || (LevelDifficulty = {}));
